<template>
  <b-container
    class="d-flex justify-content-center align-items-center not-saved-card-background saved-card-container position-relative direction-rtl fill-height border-radius-10px pb-1"
    fluid
    v-if="!cardNumber"
  >
    <!-- First Row -->
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col cols="12" class="d-flex justify-content-center align-items-center">
        <b-row class="d-flex justify-content-center">
          <b-col cols="12" class="d-flex justify-content-center">
            <b-button
              type="button"
              class="add-card-button"
              :class="{ 'brighten-up-down': buttonAnimation }"
              @click="openAddToCardModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-plus-circle-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                ></path>
              </svg>
              <span class="button-texts">
                {{ $translate("addCard") }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Second Row -->
    <b-row class="card-input-row">
      <b-col cols="12" class="direction-ltr">
        <b-row>
          <b-col
            class="px-1 d-flex justify-content-center align-items-center"
            cols="3"
            v-for="(number, i) in emptyCreditCard"
            :key="i"
          >
            <input
              @click="buttonAnimation = true"
              readonly
              :key="i"
              placeholder="****"
              class="new-form-control empty-input font-weight-bold font-size-xxs pt-2"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  <!--  Card is saved-->
  <b-container
    class="saved-card-container direction-rtl border-radius-10px pb-1 position-relative"
    :style="{ backgroundColor: getBackgroundColor + '!important' }"
    fluid
    v-else-if="cardNumber"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-center align-items-center position-absolute mt-2"
        v-if="cardActiveCondition"
      >
        <span
          class="font-size-small background-black light-grey-text border-radius-5px px-1"
        >
          {{ $translate("identityApproved") }}
        </span>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-center py-2 px-0 mx-0">
        <b-row class="d-flex justify-content-center fill-width">
          <b-col :cols="5" class="d-flex justify-content-center px-0">
            <b-row class="fill-width">
              <b-col
                cols="6"
                class="d-flex justify-content-center align-items-center p-0"
              >
                <b-img
                  :src="getBankImageSource ? getBankImageSource : null"
                  class="bank-img-min-max-size border-radius-10px"
                  fluid
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="7"
            class="d-flex justify-content-end align-items-center px-0 mt-3"
          >
            <b-button
              type="button"
              class="add-card-button"
              @click="openAddToCardModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-plus-circle-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                ></path>
              </svg>
              <span class="button-texts">
                {{ $translate("addCard") }}
              </span>
            </b-button>

            <!--            <span-->
            <!--              class="font-size-medium font-weight-bold text-white text-center bank-text-padding-right"-->
            <!--            >-->
            <!--              {{ getBankName }}-->
            <!--            </span>-->
          </b-col>

          <!--          <b-col-->
          <!--            cols="3"-->
          <!--            xl="2"-->
          <!--            align-self="center"-->
          <!--            class="d-flex justify-content-center"-->
          <!--          >-->
          <!--            <b-img-->
          <!--              :src="getBankImageSource ? getBankImageSource : null"-->
          <!--              class="bank-img-min-size border-radius-10px"-->
          <!--              fluid-->
          <!--            />-->
          <!--          </b-col>-->
        </b-row>
      </b-col>
      <b-col cols="12" class="position-absolute saved-card-input-col">
        <b-row class="pb-4">
          <b-col cols="12" class="mt-1 direction-ltr">
            <b-row>
              <b-col
                class="px-1"
                cols="3"
                v-for="(number, i) in savedCardInfo"
                :key="i"
              >
                <input
                  required
                  readonly
                  :id="`saved-credit-card-input-key${i}`"
                  :key="i"
                  :value="number.value"
                  pattern="\d*"
                  inputmode="numeric"
                  class="new-form-control saved-card-input-background custom-py"
                  v-mask="'####'"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Common from "@/common";

export default {
  name: "SavedCardContainer",
  props: {
    cardNumber: String,
    doesUserHasSavedCards: Boolean,
    userCardVerificationReq: Boolean,
    cardInfo: Object,
  },
  data() {
    return {
      buttonAnimation: false,
      emptyCreditCard: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      savedCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
    };
  },
  computed: {
    getBankName() {
      if (this.savedCardInfo)
        return Common.findBank(this.savedCardInfo)?.faName;
      else return "";
    },
    getBankImageSource() {
      if (this.savedCardInfo)
        return Common.findBank(this.savedCardInfo)?.svgAddress;
      else return null;
    },
    getBackgroundColor() {
      if (this.savedCardInfo)
        return Common.findBank(this.savedCardInfo)?.mainColor;
      else return "";
    },
    cardActiveCondition() {
      // only if the user needed terminal verification and the card was active
      return this.cardInfo.verified && this.userCardVerificationReq
        ? true
        : false;
    },
  },
  methods: {
    setCardNumber() {
      for (let i = 0; i < 4; i++) {
        let splitedCardInfo = this.cardNumber?.match(/.{1,4}/g);
        if (splitedCardInfo?.length > 0)
          this.savedCardInfo[i].value = splitedCardInfo[i];
      }
    },
    openAddToCardModal() {
      // this.buttonAnimation = false;
      this.$emit("openAddToCardModal");
    },
    // activeButtonAnimation() {
    //   let animationTimeout = {};
    //   if (animationTimeout) clearTimeout(animationTimeout);
    //   this.buttonAnimation = true;
    //   animationTimeout = setTimeout(() => {
    //     this.buttonAnimation = false;
    //   }, 2000);
    // },
  },
  watch: {
    buttonAnimation(value) {
      let timeOut = null;
      if (value)
        timeOut = setTimeout(() => {
          this.buttonAnimation = false;
        }, 1500);
      else clearTimeout(timeOut);
    },
  },
  created() {
    this.setCardNumber();
  },
};
</script>

<style scoped>
.add-card-button {
  background-image: linear-gradient(15deg, #13547a 0%, #80d0c7 100%);
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.custom-py {
  padding-top: 0.4em;
  padding-bottom: 0.4em;
}
.shetab-image-max-width {
  max-width: 50px;
}
.bank-text-padding-right {
  padding-right: 10% !important;
}

.card-input-row {
  position: absolute;
  bottom: 11%;
  width: 95%;
}
.saved-card-input-col {
  position: absolute;
  bottom: 4%;
  width: 100%;
  padding-inline: 5%;
}
.bank-img-min-max-size {
  min-width: 90px;
  max-width: 90px;
  max-height: 90px;
  min-height: 90px;
}
@media only screen and (max-width: 992px) {
  .bank-text-padding-right {
    padding-right: 4% !important;
  }
  .saved-card-input-col {
    bottom: 2%;
  }
  .bank-img-min-max-size {
    min-width: 75px;
    max-width: 75px;
    max-height: 75px;
    min-height: 75px;
  }
}

.empty-input::placeholder {
  font-size: 1rem !important;
  font-weight: bold !important;
  color: #000000;
}
.empty-input:focus-visible {
  border: none !important;
  outline: none !important;
}
.brighten-up-down {
  animation: brightenUpDown 0.2s infinite;
  --brightness-level: 100%; /* Initial brightness level */
}

@keyframes brightenUpDown {
  0%,
  100% {
    transform: scale(1);
    filter: brightness(var(--brightness-level));
  }
  50% {
    transform: scale(1.1);
    filter: brightness(120%); /* Change the brightness level as needed */
  }
}
/*.padding-top-12-percent{*/
/*  padding-top: 12%;*/
/*}*/
/*.padding-top-25-percent{*/
/*  padding-top: 25% !important;*/
/*}*/
.not-saved-card-background {
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);
}
.saved-card-container {
  min-height: 22vh;
  max-height: 25vh;
}
@media only screen and (max-height: 992px) and (min-width: 992px) {
  .saved-card-container {
    min-height: 27vh;
    max-height: 30vh;
  }
}
@media screen and (max-height: 600px) and (min-width: 1100px) {
  .saved-card-container {
    min-height: 35vh;
    max-height: 40vh;
  }

  @media screen and (max-height: 450px) {
    .second-container {
      min-height: 40vh;
      max-height: 45vh;
    }
  }
}
</style>
